export default __webpack_public_path__ + "static/media/allocation_chart.1.248352b6.png";